import React from "react";
/**
 * Returns configurable HeadingComponent to which you can pass various configuration props.
 *
 * @example
 * Here's a simple example:
 * ```
 * import React from "react";
 * import { HeadingComponent } from "@nebulr-group/nblocks-react";
 *
 * const MyComponent = () => {
 *  return (
 *      <HeadingComponent type={"h1"} size={"9xl"}>
 *        Hello World
 *      </HeadingComponent>
 *  );
 * };
 * ```
 * @param param0
 * @returns The html heading element with responsive styling.
 */
const HeadingComponent = ({
  type,
  children,
  className,
  size,
  style
}) => {
  className = className ? className + " customizable" : "customizable";
  return /*#__PURE__*/React.createElement(React.Fragment, null, type === "h1" && /*#__PURE__*/React.createElement("h1", {
    className: `${className}${getHeadingBaseSize(size)}`,
    style: style
  }, children), type === "h2" && /*#__PURE__*/React.createElement("h2", {
    className: `${className}${getHeadingBaseSize(size)}`,
    style: style
  }, children), type === "h3" && /*#__PURE__*/React.createElement("h3", {
    className: `${className}${getHeadingBaseSize(size)}`,
    style: style
  }, children), type === "h4" && /*#__PURE__*/React.createElement("h4", {
    className: `${className}${getHeadingBaseSize(size)}`,
    style: style
  }, children), type === "h5" && /*#__PURE__*/React.createElement("h5", {
    className: `${className}${getHeadingBaseSize(size)}`,
    style: style
  }, children), type === "h6" && /*#__PURE__*/React.createElement("h6", {
    className: `${className}${getHeadingBaseSize(size)}`,
    style: style
  }, children));
};

/**
 *
 * @param size
 * @returns
 */
const getHeadingBaseSize = size => {
  switch (size) {
    case "lg":
      return " text-lg";
    case "xl":
      return " text-lg xl:text-xl";
    case "2xl":
      return " text-lg lg:text-xl xl:text-2xl";
    case "3xl":
      return " text-lg md:text-xl lg:text-2xl xl:text-3xl";
    case "4xl":
      return " text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl";
    case "5xl":
      return " text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl";
    case "6xl":
      return " text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl";
    case "7xl":
      return " text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl";
    case "8xl":
      return " text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl";
    case "9xl":
      return " text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl";
    default:
      return "";
  }
};
export { HeadingComponent };